import React, { Component } from "react";
import { UploadOutlined } from "@ant-design/icons";
import { Button, Col, Form, message, Upload, Modal, Row, Spin, Typography, Input, Space, Image, InputNumber } from 'antd';
import { EditableProTable } from '@ant-design/pro-table';

const axios = require('axios').default;
const { Title, Text } = Typography;


/**
 *
 *
 * @export
 * @class ModalOrdenCompra
 * @extends {Component}
 */
class ModalOrdenCompra extends Component {


    constructor(props) {
        super(props);
        this.state = {
            loading: false,


            loadingFile: false,
            ordenes_compras: [],
            ocupados: [],
            cantidad_max: undefined,
            archivos: null,
            dataSource: [],
            editableKeys: []
        }
    }

    formModalOrdenCompra = React.createRef();
    tableModalOrdenCompra = React.createRef();


    componentDidMount() {
        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token');

        this.setState({loading: true})

        if(this.props.orden_compra_id) {
            this.getOrdenCompra()
        }
    }

    /**
     *
     *
     * @memberof ModalOrdenCompra
     * @method getOrdenCompra
     * @description Obtiene la orden de compra y los detalles de esta
     */
    getOrdenCompra = () => {
        this.setState({loading: true})
        axios.get('/ordenesCompra/get', {
            params: {
                id: this.props.orden_compra_id
            }
        })
            .then(({data}) => {
                console.clear()
                console.log(data)
                const detalles = data.orden_detalles
                const ids = detalles?.map(item => item._id)
                this.setState({
                    orden_compra: data.data,
                    dataSource: detalles,
                    editableKeys: ids
                })
            })
            .catch(error => {
                console.log(error)
            })
            .finally(() => {
                this.setState({loading: false})
            })

    }

    /**
     *
     * @memberof ModalOrdenCompra
     *
     * @method removeFile
     * @description Elimina un archivo del WebService.
     *
     * @param filename (string)
     * Recibe el nombre del archivo.
     */
     removeFile = (filename) => {
        axios.post("/voucher/delete", {
            filename
        })
            .then(res => {
                console.log("Documento removido con exito", res);
            })
            .catch(res => {
                console.log("Documento no se puedo remover", res);
            })
            .finally(() => {
                this.setState({loadingFile: false})
            })
    };

    /**
     *
     * @memberof ModalOrdenCompra
     *
     * @method normFile
     * @description Declaramos las imagenes en el row de la tabla
     *
     */
     normFile = (e) => {

        this.setState({loadingFile: true})

        const { file, fileList } = e;

        let upload = false;

        for (let x = 0; x < fileList.length; x++) {
            if (fileList[x].response) {
                fileList[x].name = fileList[x].response.filename

            }

            if (fileList[x].status !== "done" && fileList[x].response && !this.state.loading) {
                this.state.loading = true;
                this.setState({ update: !this.state.update })
                break;
            }
        }

        /**
         * Cuando se sube un archivo, se debe actualizar la lista de imagenes, cuando se selecciona eliminar, se debe actualizar la lista una vez que se elimina
         */
        if (file.status == "done") {
            this.setState({
                image: {
                    url: axios.defaults.baseURL + '/voucher/' + e.file.response.filename,
                    name: e.file.response.filename
                },
                loadingFile: false
            });

        }
        if (file.status == "removed")
            this.removeFile((file.response.filename != undefined) ? file.response.filename : file.name);
        return e && e.fileList;
    };

    /**
     *
     *
     * @param {*} row Objecto con los datos del renglon
     * @param {*} list Objeto con los datos de la tabla
     * @memberof ModalOrdenCompra
     * @method onRowChange
     * @description Actualizar los datos de la tabla
     */
    onRowChange = (row, list) => {
       this.setState({
           dataSource: list
       })
    }

    /**
     *
     *
     * @param {*} values Objecto con los datos del formulario
     * @memberof ModalOrdenCompra
     * @method onFinish
     * @description Manejar los datos del formulario y actualizar datos
     */
    onFinish = (values) => {
        // Revisar si hay una peticion en proceso
        if(this.state.loading) return

        console.log("values", values);
        console.log("dataSource", this.state.dataSource);

        // Validar que ninguna cantidad recibida exceda la cantidad faltante
        const invalidRows = this.state.dataSource.filter(row => {
            console.log(row)
            const cantidadFaltante = row?.cantidad - (row?.cantidad_recibida || 0);
            return row.recepcion > cantidadFaltante;
        });

        if (invalidRows.length > 0) {
            message.error("Hay cantidades recibidas que exceden lo permitido. Por favor, corrige los valores.");
            return;
        }


        const v = {...values}

        if(Array.isArray(v.archivos) && v.archivos?.length > 0) {
            v.archivos = v.archivos?.map(archivo =>  archivo.name) 
        }else{
            v.archivos = []
        }

        if(Array.isArray(v.firma) && v.firma?.length > 0) {
            v.firma = v.firma[0].name
        }else{
            v.firma = undefined
        }


        const payload = {
            recepciones: this.state.dataSource,
            tipo: 0, //recepecion
            orden_compra_id: this.props.orden_compra_id,
            ...v,
        }
        this.setState({loading: true})
        axios.post('/ordenesCompra/recepciones-v2', payload)
            .then(({data}) => {
                console.log(data)
                Modal.info({
                    title: 'Las recepciones han sido enviadas',
                    width: 800,
                    content: (
                        <div>
                            <label>Recepciones:</label>
                            <ul>
                                {data.insersiones?.length > 0 ? data.insersiones.map((i)=><li>{i.message}</li>) : ""}
                            </ul>
                            <label>Errores:</label>
                            <ul>
                                {data.errors?.length > 0 ? data.errors.map((i)=><li>{i.message}</li>) : "Sin errores"}
                            </ul>
                        </div>
                    ),
                    onOk() {},
                })
                this.props.onClose()
            })
            .catch(error => {
                message.error(error.response?.data?.message ?? `Error al crear la recepcion`)
                this.setState({loading: false})
            }).finally(() => {
                this.setState({loading: false})
            })
    
    } 

    columns = [
        {
            title: "Producto",
            width: "100%",
            dataIndex: "extra",
            key: "extra",
            renderFormItem: (text, { record }) => {

                let rfq_detalle_id = text.entry?.rfq_detalle_id;
                let producto = record.producto_id
                let cantidad = record.cantidad;
                let sustraendo = record?.cantidad_recibida 
                let faltante = cantidad - sustraendo
                
                return (
                    <Space>
                        <Image
                            width={80}
                            src={
                                rfq_detalle_id?.imagenes?.length > 0
                                    ? `${axios.defaults.baseURL}/upload/${rfq_detalle_id?.imagenes[0]}`
                                    : `/images/nofile.png`
                            }
                            className="product-image"
                            preview={true}
                        />
                        <Space direction="vertical" size={0}>
                            <Text className="product-text-name flex-left-column">
                                {producto ? <Text>{producto.marca} <small>({producto.np_nexus})</small></Text> : ""}
                                {producto ? <Text>{producto.sku}</Text> : ""}  
                            </Text>
                            <Text className="product-text-name">
                                Cant. {cantidad ? cantidad : 0}
                            </Text>
                            <Text className="product-text-name">
                                Pte. {faltante ? faltante : 0}
                            </Text>
                        </Space>
                    </Space>
                );
            },
        },
        {
            title:  "Cantidad Recibida",
            dataIndex:  "recepcion",
            key:  "recepcion",
            default: 0,
            width: "140px",
            formItemProps: (form, row) => {
                let recibida = row.entry?.cantidad_recibida
                let cantidad = 0;
                
                cantidad = row.entry?.cantidad - recibida

                return  {
                    rules: [
                        {
                            required: true,
                            message: "Ingrese una cantidad",
                        },
                        {
                            max: cantidad,
                            type: 'number',
                            message: "La cantidad excede lo faltante",
                        }
                    ]
                }
            },
            renderFormItem: (
                row,
                { type, defaultRender, record, ...rest },
                form
            ) => {
                let recibida = row.entry?.cantidad_recibida

                let cantidad = row.entry?.cantidad - recibida;
            
                return <InputNumber
                    controls={false}
                    defaultValue={0}
                    min={1}
                    //max={cantidad}
                    {...rest}
                    disabled={cantidad <= 0}
                />
            },
        }
    ];

    render() {
        const { loading, dataSource, editableKeys, orden_compra } = this.state;

        return (
            <Form
                onFinish={this.onFinish}
                ref={this.formModalOrdenCompra}
                layout="vertical"
            >
                <Spin spinning={loading}>
                    <Row justify="center">
                        <Col xs={24}>
                            <Title level={3} className="text-center">Nueva Recepción</Title>
                        </Col>
                        <Col xs={24} className="flex-left-column mb-1">
                            <Space> 
                                <Text strong> 
                                    Cliente: 
                                </Text>  
                                <Text> 
                                    {orden_compra?.cliente_id?.nombre_completo ? 
                                        `${orden_compra?.cliente_id?.nombre_completo} (${orden_compra?.cliente_id.razon_social})` 
                                        : "Sin cliente"} 
                                </Text> 
                            </Space>
                            <Space> 
                                <Text strong> 
                                    Alamcén: 
                                </Text>  
                                <Text> 
                                    {orden_compra?.almacen_id?.direccion ? 
                                        `${orden_compra?.almacen_id?.direccion}` 
                                        : "Sin Almacén"} 
                                </Text> 
                            </Space>
                        </Col>
                        <Col xs={24}>
                            <EditableProTable
                                headerTitle=""
                                columns={this.columns}
                                rowKey="_id"
                                value={dataSource}
                                recordCreatorProps={{
                                    style: { display: "none" },
                                }}
                                editable={{
                                    //form,
                                    type: "multiple",
                                    onValuesChange: this.onRowChange,
                                    editableKeys: editableKeys,
                                }}
                            />
                        </Col>
                        <Col xs={21} className="mt-1">
                            <Form.Item
                                label="Nombre"
                                name="nombre"
                                rules={[
                                    {
                                        required: true,
                                        message: "Ingresa el nombre"
                                    }
                                ]}
                            >
                                <Input/>
                            </Form.Item>
                        </Col>

                                <Col xs={21} lg={9}>
                                    <Form.Item
                                        label="Archivos"
                                        name="archivos"
                                        getValueFromEvent={this.normFile}
                                        valuePropName="fileList"
                                    >
                                        <Upload
                                            action={axios.defaults.baseURL + "/voucher/add"}
                                            style={{
                                                width: "100%"
                                            }}
                                            multiple={true}
                                        >
                                            <Button>
                                                <UploadOutlined /> Subir Archivo
                                            </Button>
                                        </Upload>
                                    </Form.Item>
                                </Col>
                                <Col xs={0} lg={3}></Col>
                            
                        <Col xs={21} lg={9}>
                            <Form.Item
                                label="Firma"
                                name="firma"
                                getValueFromEvent={this.normFile}
                                valuePropName="fileList"
                                /*rules={[
                                    {
                                        required: true,
                                        message: "Sube la firma"
                                    }
                                ]}*/
                            >
                                <Upload
                                    action={axios.defaults.baseURL + "/upload/add"}
                                    style={{
                                        width: "100%"
                                    }}
                                    maxCount={1}
                                >
                                    <Button>
                                        <UploadOutlined /> Subir Archivo
                                    </Button>
                                </Upload>
                            </Form.Item>
                        </Col>
                        
                        <Col xs={4}>
                            <Form.Item>
                                <Button
                                    htmlType="submit"
                                    type="primary"
                                    loading={this.state.loading || this.state.loadingFile}
                                >
                                    Guardar
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Spin>
            </Form>
        )
    }
}

/**
 * @description Según el modal
 */
export default function (props) {

    const { visible, onClose } = props

    return (
        <Modal
            visible={visible}
            onCancel={onClose}
            title={null}
            footer={null}
            closable={false}
            maskClosable={true}
            destroyOnClose={true}
            zIndex={1000}
            width={1000}
        >
            <ModalOrdenCompra {...props} />
        </Modal>
    )
}
